import {
  createErrorType,
  createFetchType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
} from '../actionHelpers';

const GET_TRIGGER_ORDER_QUOTE_SCOPE = 'GET_TRIGGER_ORDER_QUOTE';
export const GET_TRIGGER_ORDER_QUOTE = createFetchType(
  GET_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const GET_TRIGGER_ORDER_QUOTE_SUCCESS = createSuccessType(
  GET_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const GET_TRIGGER_ORDER_QUOTE_ERROR = createErrorType(
  GET_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const GET_TRIGGER_ORDER_QUOTE_LOADING = createLoadingType(
  GET_TRIGGER_ORDER_QUOTE_SCOPE,
);

// A trigger order's details, from the single transaction API. Deliberately its
// own scope, not PORTFOLIO_TRANSACTIONS_SINGLE: that one is reduced into the
// singleTransaction slice the transaction tables open TransactionDetails off,
// and shares one takeLatest, so a trigger order's details must not land there or
// cancel (or be canceled by) a table's call. Nothing reduces these types; the
// response goes to the caller through onSuccess. SUCCESS and ERROR still exist
// because loadingMiddleware clears the LOADING flag on them.
const GET_TRIGGER_ORDER_DETAILS_SCOPE = 'GET_TRIGGER_ORDER_DETAILS';
export const GET_TRIGGER_ORDER_DETAILS = createFetchType(
  GET_TRIGGER_ORDER_DETAILS_SCOPE,
);
export const GET_TRIGGER_ORDER_DETAILS_SUCCESS = createSuccessType(
  GET_TRIGGER_ORDER_DETAILS_SCOPE,
);
export const GET_TRIGGER_ORDER_DETAILS_ERROR = createErrorType(
  GET_TRIGGER_ORDER_DETAILS_SCOPE,
);
export const GET_TRIGGER_ORDER_DETAILS_LOADING = createLoadingType(
  GET_TRIGGER_ORDER_DETAILS_SCOPE,
);

// "Set target price again" on an expired Target Price Order. The details modal,
// on whichever page it is open, asks for the Target Price flow to open for the
// order's product and vault; the Header, which hosts the flow on every page,
// takes the request (see useTargetPriceAgain) and reports how it ended, so the
// modal can show a spinner until the flow is there. Plain state, no saga: only
// the reducer handles these.
export const REQUEST_TARGET_PRICE_AGAIN = 'REQUEST_TARGET_PRICE_AGAIN';
export const FINISH_TARGET_PRICE_AGAIN = 'FINISH_TARGET_PRICE_AGAIN';

// Where a request is: waiting to be carried out, or how it ended. The flow was
// opened; the account was blocked with the verification popup instead; or
// nothing could be opened (the product isn't in the catalog any more, a lookup
// failed, the request went stale).
export const TARGET_PRICE_AGAIN_STATUS = {
  PENDING: 'pending',
  OPENED: 'opened',
  BLOCKED: 'blocked',
  DROPPED: 'dropped',
};

const EXECUTE_TRIGGER_ORDER_QUOTE_SCOPE = 'EXECUTE_TRIGGER_ORDER_QUOTE';
export const EXECUTE_TRIGGER_ORDER_QUOTE = createSubmitType(
  EXECUTE_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const EXECUTE_TRIGGER_ORDER_QUOTE_SUCCESS = createSuccessType(
  EXECUTE_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const EXECUTE_TRIGGER_ORDER_QUOTE_ERROR = createErrorType(
  EXECUTE_TRIGGER_ORDER_QUOTE_SCOPE,
);
export const EXECUTE_TRIGGER_ORDER_QUOTE_LOADING = createLoadingType(
  EXECUTE_TRIGGER_ORDER_QUOTE_SCOPE,
);

const CANCEL_TRIGGER_ORDER_SCOPE = 'CANCEL_TRIGGER_ORDER';
export const CANCEL_TRIGGER_ORDER = createSubmitType(
  CANCEL_TRIGGER_ORDER_SCOPE,
);
export const CANCEL_TRIGGER_ORDER_SUCCESS = createSuccessType(
  CANCEL_TRIGGER_ORDER_SCOPE,
);
export const CANCEL_TRIGGER_ORDER_ERROR = createErrorType(
  CANCEL_TRIGGER_ORDER_SCOPE,
);
export const CANCEL_TRIGGER_ORDER_LOADING = createLoadingType(
  CANCEL_TRIGGER_ORDER_SCOPE,
);
